<template>
  <!-- Contact Section start -->
  <section
    id="signUp"
    class="contact"
  >
    <div class="contact-decor">
      <div class="contact-circle1">
        <img
          src="../assets/images/main-banner12.png"
          alt=""
        >
      </div>
      <div class="contact-circle2">
        <img
          src="../assets/images/main-banner1.png"
          alt=""
        >
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-lg-8 col-sm-12">
          <div class="contact-us">
            <div class="w-100">
              <h2 class="title">
                <span>Sign </span>Up Today!
              </h2>
              <form
                id="myform"
                class="theme-form"
                method="get"
              >
                <div class="form-group">
                  <div class="row">
                    <div
                      id="mail_alert_class"
                      class="alert alert-success alert-dismissible d-none"
                    >
                      <a
                        href="#"
                        class="close"
                        data-dismiss="alert"
                        aria-label="close"
                      >&times;</a>
                      <div id="alert_mail" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 col-md-6 md-fgrup-margin">
                      <input
                        id="fullname"
                        v-model="name"
                        type="text"
                        class="form-control"
                        name="fullname"
                        placeholder="your name"
                        required="required"
                      >
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <input
                        id="phone"
                        v-model="phone"
                        type="number"
                        class="form-control"
                        name="phone"
                        placeholder="phone"
                        required="required"
                      >
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <input
                    id="email"
                    v-model="email"
                    type="email"
                    class="form-control"
                    name="email"
                    placeholder="email address"
                    required="required"
                  >
                </div>
                <div class="form-group">
                  <textarea
                    id="message"
                    v-model="message"
                    class="form-control"
                    name="message"
                    rows="4"
                    placeholder="message"
                    required="required"
                  />
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-6 text-message hide">
                    Sign Up Successfully Initiated
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div class="form-button">
                      <input
                        id="send"
                        type="button"
                        name="send"
                        class="btn btn-custom theme-color"
                        value="send"
                        :disabled="!enableForm()"
                        @click="contact"
                      >
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-lg-4 d-medium-none-lg">
          <div class="contact-right" />
        </div>
      </div>
    </div>
  </section>
  <!-- Contact Section End -->
</template>
<script>
import $ from 'jquery'

export default {
  name: 'VendorSignUp',
  data() {
    return {
      name: '',
      phone: '',
      email: '',
      message: '',
      sent: false,
    }
  },
  methods: {
    contact() {
      this.axios
        .post(`${process.env.ROOT_API}/contact`, {
          name: this.name,
          phone: this.phone,
          email: this.email,
          message: this.message,
        })
        .then(response => {
          $('.text-message').removeClass('hide')
          this.sent = true
        })
    },
    enableForm() {
      return (
        !this.sent &&
        this.name.length &&
        this.phone.length &&
        this.email.length &&
        this.message.length
      )
    },
  },
}
</script>
<style scoped>
.hide {
  opacity: 0;
}
.text-message {
  padding-left: 21px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/vendorSignUp.vue